function getDY_StackerConfig(config) {
  const DY_SR = {
    international: {
      flow: {
        enableInternationalCheckout: false,
      },
    },
    config: {
      global: {
        // Required for Routing
        // [Remove on Prod where App is hosted directly]
        // As URLs are not same on Prod, Stage, Dev and other env, [URL Shortening]
        // So only the extra URL will come here [i.e. in between Host and React Router]
        // [hostname.domain.com<baseURL><React_Routing>]
        baseURL: "/david-yurman",

        // Required for API Calls
        // Not required on Local Development as we have different folder for Mock JSON
        // [hostname.domain.com<baseAPIURL><REST_End_Point>]
        // baseAPIURL: '/content/david-yurman/us/en' ,

        //SMITH local
        baseAPIURL: "https://local-davidyurman-api.smithdev.co",

        //Required for PDP PLP search calls
        baseStore: "dy",
        cookieLengthOfDays: 10,
        countryDisable: false,
        defaultFallbackImgSrc: "/content/dam/david-yurman/image-not-found.jpg",
        defaultLoadingImgSrc:
          "/content/dam/david-yurman/default-placeholder-women.png",
        defaultLoadingImgSrcMen:
          "/content/dam/david-yurman/default-placeholder-men.png",
        defaultLoadingImgSrcWomen:
          "/content/dam/david-yurman/default-placeholder-women.png",
        defaultSelectedCountryCode: "US",
        defaultSelectedCountryCurrencyCode: "USD",
        diamondCellarSiteURL: "http://www.diamondcellar.com",
        holidayGiftGuidePath: "/holiday-gift-guide",
        isAffirmEnabled: true,
        isGiftCardEnabled: true,
        isInternationalShippingEnabled: false,
        isProduction: "false",
        isPriceDisclaimerEnabled: true,
        tooltipGenericPositionTop: "top",
        tooltipGenericPositionTopRight: "topRight",
        minimumQuantity: 3,
        locale: {
          en: { lang: "en", currency: "USD" },
          enUS: { lang: "en-US", currency: "USD" },
          "en-US": { lang: "en", currency: "USD" },
          "fr-CA": { lang: "fr", currency: "CAD" },
          fr: { lang: "fr", currency: "EUR" },
          "fr-FR": { lang: "fr", currency: "EUR" },
        },
      },
      pdp: {
        swatchCarouselLimit: 6,
      },
      searchPage: {
        // Search, PLP related API calls
        // It will be passed back to AEM as query-params
        basePath: "/search.html",
        sort: "low_price asc",
        pageSize: 50,
      },
      paypal: {
        env: "sandbox",
      },
      captcha: {
        // isCaptchaEnabled: false // Default value is true if not passed.,
        siteKey: "6Lfxh14UAAAAAB-Sl_CNpFgbT_oVysUy5WIGHHOy",
      },
      googleLookup: {
        key: "AIzaSyAOSxn9GVvSXC30XlIFh47cQZXYiKxF1iw",
      },
    },
    data: {
      isNarvarNotify: false,
      pid: "R11028DSS",
      userDetails: {
        anonymous: true,
        emailID: "user2@ravi.com",
        firstName: "User1",
        lastName: "Yurman",
        status: "success",
        isCsAgent: false,
        isCsManager: false,
      },
      promoCarousel: {
        carousel1: {
          showCarouselDots: "true",
          imgSrcList: [
            {
              src: "https://img.davidyurman.com/is/image/DavidYurmanNew/holiday-gift-guide-wedding-meganav-promo?$mktg$",
              alt: "",
            },
            {
              src: "https://img.davidyurman.com/is/image/DavidYurmanNew/holiday-gift-guide-mens-meganav-promo1?$mktg$",
              alt: "",
            },
            {
              src: "https://img.davidyurman.com/is/image/DavidYurmanNew/holiday-gift-guide-mens-meganav-promo1?$mktg$",
              alt: "",
            },
          ],
        },
      },
    },
  }
  //TODO: this should probably be refactored into proper application state initialized by routing
  if (config === "bracelets") {
    DY_SR.config.braceletStacker = {
      //tutorial:'/content/david-yurman/us/en/promotions/bracelet-builder/bracelet-tutorial-carousel',
      tutorial:
        "/content/david-yurman/language-masters/en/promotions/bracelet-builder/bracelet-tutorial-carousel",
      braceletCategory: "builder/bracelet-builder",
      braceletProducts: "40",
      braceletLimit: "25",
    }
    DY_SR.data.facets = [
      {
        order: 0,
        code: "all_categories",
        name: "Type",
        category: "false",
        rangeFilter: false,
        decimalFilter: false,
        values: [
          {
            count: "110",
            name: "Bangle",
            code: "womenswomens-braceletsbangle-bracelets",
            selected: "false",
          },
          {
            count: "4",
            name: "Bead",
            code: "womenswomens-braceletsbeaded-bracelets",
            selected: "false",
          },
          {
            count: "38",
            name: "Chain",
            code: "womenswomens-braceletschain-bracelets",
            selected: "false",
          },
          {
            count: "141",
            name: "Cuff",
            code: "womenswomens-braceletscuff-bracelets",
            selected: "false",
          },
          {
            count: "35",
            name: "Soft",
            code: "womenswomens-braceletssoft-bracelets",
            selected: "false",
          },
          {
            count: "118",
            name: "Stackable",
            code: "womenswomens-braceletsstacking-bracelets",
            selected: "false",
          },
        ],
      },
      {
        order: 4,
        code: "dyprice",
        name: "Price",
        category: "false",
        rangeFilter: true,
        decimalFilter: false,
        values: [
          {
            count: "54",
            name: "$0-$750",
            code: "0 TO 750",
            start: "0",
            end: "750",
            selected: "false",
          },
          {
            count: "87",
            name: "$750-$1,500",
            code: "750 TO 1500",
            start: "750",
            end: "1500",
            selected: "false",
          },
          {
            count: "91",
            name: "$1,500-$3,000",
            code: "1500 TO 3000",
            start: "1500",
            end: "3000",
            selected: "false",
          },
          {
            count: "51",
            name: "$3,000-$5,000",
            code: "3000 TO 5000",
            start: "3000",
            end: "5000",
            selected: "false",
          },
          {
            count: "67",
            name: "Above $5,000",
            code: "5000 TO *",
            start: "5000",
            end: "*",
            selected: "false",
          },
        ],
      },
      {
        order: 5,
        code: "material",
        name: "Material",
        category: "false",
        rangeFilter: false,
        decimalFilter: false,
        values: [
          {
            count: "3",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-MULTI-COLORED-GOLD1?$alpha_enabled$",
            name: "18K MULTI-COLORED GOLD",
            code: "18K MULTI-COLORED GOLD",
            selected: "false",
          },
          {
            count: "12",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-ROSE-GOLD1?$alpha_enabled$",
            name: "18k Rose Gold",
            code: "18k Rose Gold",
            selected: "false",
          },
          {
            count: "1",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-ROSE-GOLD-AND-18K-WHITE-GOLD1?$alpha_enabled$",
            name: "18K Rose Gold and 18k White Gold",
            code: "18K Rose Gold and 18k White Gold",
            selected: "false",
          },
          {
            count: "34",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-WHITE-GOLD1?$alpha_enabled$",
            name: "18k White Gold",
            code: "18k White Gold",
            selected: "false",
          },
          {
            count: "1",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-WHITE-GOLD-AND-18K-YELLOW-GOLD1?$alpha_enabled$",
            name: "18k White Gold and 18k Yellow Gold",
            code: "18k White Gold and 18k Yellow Gold",
            selected: "false",
          },
          {
            count: "117",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-YELLOW-GOLD1?$alpha_enabled$",
            name: "18k Yellow Gold",
            code: "18k Yellow Gold",
            selected: "false",
          },
          {
            count: "2",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/18K-YELLOW-GOLD-AND-STERLING-SILVER1?$alpha_enabled$",
            name: "18k Yellow Gold and Sterling Silver",
            code: "18k Yellow Gold and Sterling Silver",
            selected: "false",
          },
          {
            count: "1",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/ALUMINUM1?$alpha_enabled$",
            name: "Aluminum",
            code: "Aluminum",
            selected: "false",
          },
          {
            count: "64",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/MIXED-METALS1?$alpha_enabled$",
            name: "Mixed Metals",
            code: "Mixed Metals",
            selected: "false",
          },
          {
            count: "101",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/STERLING-SILVER1?$alpha_enabled$",
            name: "Sterling Silver",
            code: "Sterling Silver",
            selected: "false",
          },
        ],
      },
      {
        order: 7,
        code: "dycolor",
        name: "Gemstone Color",
        category: "false",
        rangeFilter: false,
        decimalFilter: false,
        values: [
          {
            count: "11",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/BLACK1?$alpha_enabled$",
            name: "Black",
            code: "Black",
            selected: "false",
          },
          {
            count: "4",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/BLACK1?$alpha_enabled$",
            name: "black",
            code: "black",
            selected: "false",
          },
          {
            count: "21",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/BLUE1?$alpha_enabled$",
            name: "Blue",
            code: "Blue",
            selected: "false",
          },
          {
            count: "245",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/CLEAR1?$alpha_enabled$",
            name: "Clear",
            code: "Clear",
            selected: "false",
          },
          {
            count: "10",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/GOLD1?$alpha_enabled$",
            name: "Gold",
            code: "Gold",
            selected: "false",
          },
          {
            count: "7",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/GREEN1?$alpha_enabled$",
            name: "Green",
            code: "Green",
            selected: "false",
          },
          {
            count: "4",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/NA1?$alpha_enabled$",
            name: "NA",
            code: "NA",
            selected: "false",
          },
          {
            count: "5",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/ORANGE1?$alpha_enabled$",
            name: "Orange",
            code: "Orange",
            selected: "false",
          },
          {
            count: "4",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/PINK1?$alpha_enabled$",
            name: "Pink",
            code: "Pink",
            selected: "false",
          },
          {
            count: "4",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/PURPLE1?$alpha_enabled$",
            name: "Purple",
            code: "Purple",
            selected: "false",
          },
          {
            count: "9",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/RED1?$alpha_enabled$",
            name: "Red",
            code: "Red",
            selected: "false",
          },
          {
            count: "1",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/TURQUOISE1?$alpha_enabled$",
            name: "TURQUOISE",
            code: "TURQUOISE",
            selected: "false",
          },
          {
            count: "9",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/WHITE1?$alpha_enabled$",
            name: "White",
            code: "White",
            selected: "false",
          },
          {
            count: "2",
            imageUrl:
              "https://img.davidyurman.com/is/image/DavidYurmanNew/YELLOW1?$alpha_enabled$",
            name: "Yellow",
            code: "Yellow",
            selected: "false",
          },
        ],
      },
      {
        order: 8,
        code: "all_collections",
        name: "Collection",
        category: "true",
        rangeFilter: false,
        decimalFilter: false,
        values: [
          {
            count: "4",
            name: "Albion® ",
            code: "womenscollectionsalbion-collection",
            selected: "false",
          },
          {
            count: "2",
            name: "Barrels ",
            code: "womenscollectionsbarrels-collection",
            selected: "false",
          },
          {
            count: "2",
            name: "Belmont® ",
            code: "womenscollectionsbelmont-collection",
            selected: "false",
          },
          {
            count: "5",
            name: "Bijoux ",
            code: "womenscollectionsbijoux-collection",
            selected: "false",
          },
          {
            count: "77",
            name: "Cable ",
            code: "womenscollectionscable-collection",
            selected: "false",
          },
          {
            count: "8",
            name: "Cable Buckle ®",
            code: "womenscollectionscable-buckle-collection",
            selected: "false",
          },
          {
            count: "16",
            name: "Cable Collectibles® ",
            code: "womenscollectionscable-collectibles-collection",
            selected: "false",
          },
          {
            count: "1",
            name: "Cable Loop ",
            code: "womenscollectionscable-loop-collection",
            selected: "false",
          },
          {
            count: "29",
            name: "Chain ",
            code: "womenscollectionschain-collection",
            selected: "false",
          },
          {
            count: "11",
            name: "Châtelaine® ",
            code: "womenscollectionschatelaine-collection",
            selected: "false",
          },
          {
            count: "20",
            name: "Continuance® ",
            code: "womenscollectionscontinuance-collection",
            selected: "false",
          },
          {
            count: "11",
            name: "DY Crossover® ",
            code: "womenscollectionsdy-crossover-collection",
            selected: "false",
          },
          {
            count: "9",
            name: "DY Helena ",
            code: "womenscollectionsdy-helena-collection",
            selected: "false",
          },
          {
            count: "10",
            name: "DY Madison® ",
            code: "womenscollectionsdy-madison-collection",
            selected: "false",
          },
          {
            count: "22",
            name: "DY Renaissance® ",
            code: "womenscollectionsdy-renaissance-collection",
            selected: "false",
          },
          {
            count: "1",
            name: "DY Supernova ",
            code: "womenscollectionsdy-supernova-collection",
            selected: "false",
          },
          {
            count: "1",
            name: "Infinity ",
            code: "womenscollectionsinfinity-collection",
            selected: "false",
          },
          {
            count: "4",
            name: "Labyrinth® ",
            code: "womenscollectionslabyrinth-collection",
            selected: "false",
          },
          {
            count: "6",
            name: "Novella ",
            code: "womenscollectionsnovella-collection",
            selected: "false",
          },
          {
            count: "18",
            name: "Pavé Flex ",
            code: "womenscollectionspave-flex-collection",
            selected: "false",
          },
          {
            count: "22",
            name: "Petite Pavé ",
            code: "womenscollectionspetite-pave-collection",
            selected: "false",
          },
          {
            count: "18",
            name: "Pure Form® ",
            code: "womenscollectionspure-form-collection",
            selected: "false",
          },
          {
            count: "2",
            name: "Rio Rondelle ",
            code: "womenscollectionsrio-rondelle-collection",
            selected: "false",
          },
          {
            count: "1",
            name: "Sculpted Cable ",
            code: "womenscollectionssculpted-cable-collection",
            selected: "false",
          },
          {
            count: "21",
            name: "Solari ",
            code: "womenscollectionssolari-collection",
            selected: "false",
          },
          {
            count: "4",
            name: "Starburst ",
            code: "womenscollectionsstarburst-collection",
            selected: "false",
          },
          {
            count: "16",
            name: "Stax ",
            code: "womenscollectionsstax-collection",
            selected: "false",
          },
          {
            count: "7",
            name: "Tides ",
            code: "womenscollectionstides-collection",
            selected: "false",
          },
          {
            count: "8",
            name: "Wellesley Link ",
            code: "womenscollectionswellesley-link-collection",
            selected: "false",
          },
          {
            count: "2",
            name: "Wheaton® ",
            code: "womenscollectionswheaton-collection",
            selected: "false",
          },
          {
            count: "3",
            name: "Wisteria ",
            code: "womenscollectionswisteria-collection",
            selected: "false",
          },
          {
            count: "1",
            name: "X ",
            code: "womenscollectionsx-collection",
            selected: "false",
          },
        ],
      },
      {
        order: 9,
        code: "metals",
        name: "Metals",
        category: "false",
        rangeFilter: false,
        decimalFilter: false,
        values: [
          {
            count: "3",
            name: "18K MULTI-COLORED GOLD",
            code: "18K MULTI-COLORED GOLD",
            selected: "false",
          },
          {
            count: "1",
            name: "18K Rose Gold and 18k White Gold",
            code: "18K Rose Gold and 18k White Gold",
            selected: "false",
          },
          {
            count: "1",
            name: "18k White Gold and 18k Yellow Gold",
            code: "18k White Gold and 18k Yellow Gold",
            selected: "false",
          },
          {
            count: "2",
            name: "18k Yellow Gold and Sterling Silver",
            code: "18k Yellow Gold and Sterling Silver",
            selected: "false",
          },
          {
            count: "1",
            name: "Aluminum",
            code: "Aluminum",
            selected: "false",
          },
          {
            count: "43",
            name: "MIXED METALS",
            code: "MIXED METALS",
            selected: "false",
          },
          {
            count: "12",
            name: "ROSE GOLD",
            code: "ROSE GOLD",
            selected: "false",
          },
          {
            count: "1",
            name: "Silver and 18K Rose Gold",
            code: "Silver and 18K Rose Gold",
            selected: "false",
          },
          {
            count: "3",
            name: "Silver and Darkened Sterling Silver",
            code: "Silver and Darkened Sterling Silver",
            selected: "false",
          },
          {
            count: "141",
            name: "STERLING SILVER",
            code: "STERLING SILVER",
            selected: "false",
          },
          {
            count: "20",
            name: "Sterling Silver and 14k Yellow Gold",
            code: "Sterling Silver and 14k Yellow Gold",
            selected: "false",
          },
          {
            count: "34",
            name: "WHITE GOLD",
            code: "WHITE GOLD",
            selected: "false",
          },
          {
            count: "117",
            name: "YELLOW GOLD",
            code: "YELLOW GOLD",
            selected: "false",
          },
        ],
      },
      {
        order: 10,
        code: "sizes",
        name: "Size",
        category: "false",
        rangeFilter: false,
        decimalFilter: true,
        values: [
          {
            count: "2",
            name: "2x",
            code: "2x",
            selected: "false",
          },
          {
            count: "1",
            name: "3x",
            code: "3x",
            selected: "false",
          },
          {
            count: "1",
            name: "6 inches",
            code: "6 inches",
            selected: "false",
          },
          {
            count: "2",
            name: "6.75 inches",
            code: "6.75 inches",
            selected: "false",
          },
          {
            count: "5",
            name: "7 inches",
            code: "7 inches",
            selected: "false",
          },
          {
            count: "1",
            name: "7.5",
            code: "7.5",
            selected: "false",
          },
          {
            count: "7",
            name: "7.5 inches",
            code: "7.5 inches",
            selected: "false",
          },
          {
            count: "4",
            name: "8 inches",
            code: "8 inches",
            selected: "false",
          },
          {
            count: "1",
            name: "8.5 inches",
            code: "8.5 inches",
            selected: "false",
          },
          {
            count: "4",
            name: "8.25 inches",
            code: "8.25 inches",
            selected: "false",
          },
          {
            count: "2",
            name: "8.75 inches",
            code: "8.75 inches",
            selected: "false",
          },
          {
            count: "4",
            name: "9 inches",
            code: "9 inches",
            selected: "false",
          },
          {
            count: "1",
            name: "9.5 inches",
            code: "9.5 inches",
            selected: "false",
          },
          {
            count: "1",
            name: "10 inches",
            code: "10 inches",
            selected: "false",
          },
          {
            count: "12",
            name: "extra large",
            code: "extra large",
            selected: "false",
          },
          {
            count: "6",
            name: "extra small",
            code: "extra small",
            selected: "false",
          },
          {
            count: "281",
            name: "large",
            code: "large",
            selected: "false",
          },
          {
            count: "296",
            name: "medium",
            code: "medium",
            selected: "false",
          },
          {
            count: "30",
            name: "one size",
            code: "one size",
            selected: "false",
          },
          {
            count: "261",
            name: "small",
            code: "small",
            selected: "false",
          },
        ],
      },
    ]
  } else if (config === "amulets") {
    DY_SR.config.amuletStacker = {
      tutorial:
        "/content/david-yurman/us/en/promotions/amulet-builder/amulet-builder-carousel.html",
      necklaceCategory: "buildernecklace\u002Dbuilder",
      amuletCategory: "builderamulet\u002Dbuilder",
      necklaceProducts: "50",
      amuletProducts: "50",
    }
  }

  return DY_SR
}

let dy_target = "bracelets"

export function setDY(target) {
  dy_target = target
}

export function getDYArea() {
  return dy_target
}

export function getDY_SR(target) {
  const DY_SR = getDY_StackerConfig(target ?? dy_target)
  return {
    ...DY_SR,
    config: DY_SR.config || {
      global: DY_SR.config?.global || {},
    },
  }
}
